export default __webpack_public_path__ + "static/media/online-shop-2.ca0b84fb.png";